import { observer } from "mobx-react-lite"
import styles from "./styles.module.scss"
import { ModalCheckbox } from "../../../../atoms/ModalCheckbox"
import { makeAutoObservable } from "mobx"
import { useMemo } from "react"

class NavigatorFiltersModalStore {
  navigatorMessageTypes: string[]

  constructor(selectedValues: string[]) {
    this.navigatorMessageTypes = selectedValues
    makeAutoObservable(this)
  }

  toggleNavigatorMessageType(type: string) {
    this.navigatorMessageTypes = this.navigatorMessageTypes.includes(type)
      ? this.navigatorMessageTypes.filter((t) => t !== type)
      : [...this.navigatorMessageTypes, type]
  }

  resetFilters() {
    this.navigatorMessageTypes = []
  }
}

export const NavigatorFiltersModal = observer(
  ({
    selectedValues,
    onSubmit,
  }: {
    selectedValues: string[]
    onSubmit: (value: string[]) => void
  }) => {
    const store = useMemo(() => new NavigatorFiltersModalStore(selectedValues), [])

    return (
      <div className={styles.filterContainer}>
        <p className={styles.filterName}>Message type</p>
        <div className={styles.filterList}>
          <ModalCheckbox
            label="Quote"
            isChecked={store.navigatorMessageTypes.includes("quote")}
            onPress={() => store.toggleNavigatorMessageType("quote")}
          />
          <ModalCheckbox
            label="Cruise"
            isChecked={store.navigatorMessageTypes.includes("cruise")}
            onPress={() => store.toggleNavigatorMessageType("cruise")}
          />
        </div>
        <div className={styles.filterButtonsContainer}>
          <button
            type="button"
            className={styles.resetButton}
            onClick={() => {
              store.resetFilters()
            }}
          >
            Reset
          </button>
          <button
            type="button"
            className={styles.submitFiltersButton}
            onClick={() => {
              onSubmit(store.navigatorMessageTypes)
            }}
          >
            Apply
          </button>
        </div>
      </div>
    )
  },
)
